<template>
     <div class="inPage">
      <router-view></router-view>
     </div>
</template>

<script>
export default {
  data() {
    return {
        isZhong:false
      
    };
  },
  created(){
        const language = this.$cookies.get('language');
        let isZhong;
        if(language==="zhong"){
            isZhong = true;
        }else{
            isZhong = false;
        }
        this.isZhong = isZhong;
  }
};
</script>
<style lang="scss" scoped>
.inPage{
    height: 100%;
}
</style>
 


// WEBPACK FOOTER //
// src/pages/Products/Products.vue